exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popper-class-dict-select .el-select-dropdown__wrap{max-height:346px}", ""]);

// exports
